<template>
  <div id="main">
     <v-dialog v-model="showGrade" max-width="800px" attach="#main-page" >
        <view-grade
            v-if="showGrade "
            :graded_lead="coachup2.grade_id"
            @close-parent="showGrade=false"
        ></view-grade>
     </v-dialog>


      <v-card elevation="0">
        <v-card-title v-if="!compact">
          <span class="headline">View Coachup Details</span>
           <v-btn v-if="showPrint" small icon :to="print_link" target="_blank">
              <v-icon>print</v-icon>
           </v-btn>

          <v-spacer></v-spacer>
          <v-btn icon v-on:click="close" v-if="showX">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="margin-top: -30px">
          <v-container fluid grid-list-md page>
            <v-layout wrap>

              <v-flex v-if="coachup2">

                 <div class="heading ">Coach/Coachee</div>
                 <div class="hr" style="margin-top: -10px; margin-bottom: 10px"/>
                <div :class="heading_class">Dealership: <span class="value"> {{coachup2.dealership.name}} </span></div>
                <div :class="heading_class">Sales Person: <span class="value">  {{coachup2.coachee.name}} </span> </div>
                <div :class="heading_class">Manager/Coach: <span class="value"> {{coachup2.coach.name}} </span> </div>


                 <div class="heading mt-1" style="display: flex; align-items: flex-end">
                    <div>Graded Lead</div>
                    <v-spacer/>
                    <v-btn v-if="coachup.grade_id"
                        small color="primary" @click="showGrade=true">See Graded Lead</v-btn>
                 </div>
                 <div class="hr" style="margin-top: -10px; margin-bottom: 10px"/>



                 <!--<template v-if="!compact">-->
                 <!--   <div :class="heading_class">Grade: <span class="value"> {{coachup2.grade_id.grade_letter}} </span> </div>-->
                 <!--   <div :class="heading_class">Curriculum: <span class="value"> {{coachup2.grade_id.curriculum.name}} </span> </div>-->
                 <!--   <div :class="heading_class">Lead Source: <span class="value"> {{coachup2.grade_id.info_lead.lead_source}} </span> </div>-->
                 <!--   <div :class="heading_class">Customer:-->
                 <!--      <span class="value">  {{coachup2.grade_id.info_customer.name_first}} {{coachup2.grade_id.info_customer.name_last}}</span>-->
                 <!--   </div>-->
                 <!--   <div :class="heading_class">Vehicle: <span class="value"> {{coachup2.grade_id.info_lead.wanted_vehicle}} </span> </div>-->
                 <!--   <div :class="heading_class">Date In: <span class="value"> {{fmt_date(coachup2.grade_id.info_lead.lead_arrived_date)}} </span> </div>-->
                 <!--</template>-->

                 <div style="display: flex; width: 100%">
                    <div style="width: 50%">
                       <div :class="heading_class">Grade: <span class="value"> {{coachup2.grade_id.grade_letter}} </span> </div>
                       <div :class="heading_class">Curriculum: <span class="value"> {{coachup2.grade_id.curriculum.name}} </span> </div>
                       <div :class="heading_class">Lead Source: <span class="value"> {{coachup2.grade_id.info_lead.lead_source}} </span> </div>
                    </div>
                    <div style="width: 50%">
                       <div :class="heading_class">Customer:
                          <span class="value">  {{coachup2.grade_id.info_customer.name_first}} {{coachup2.grade_id.info_customer.name_last}}</span>
                       </div>
                       <div :class="heading_class">Vehicle: <span class="value"> {{coachup2.grade_id.info_lead.wanted_vehicle}} </span> </div>
                       <div :class="heading_class">Date In: <span class="value"> {{fmt_date(coachup2.grade_id.info_lead.lead_arrived_date)}} </span> </div>
                    </div>
                 </div>




                 <div class="heading mt-3" style="margin-bottom: -7px">Coach's Comments:</div>
                 <div class="hr" style="margin-top: -10px; margin-bottom: 10px"/>
                <div class="comments" v-html="txt_to_html(coachup2.comments_external)"> </div>


                <!--<div v-if="$auth.profile.acct_type === 'AGENCY' && coachup2.comments_internal !== ''" class="mt-3">-->
                <!--  <div class="heading pb-0">Internel Comments (Agency View Only):</div>-->
                <!--  <div class="comments" v-html="txt_to_html(coachup2.comments_internal)"> </div>-->
                <!--</div>-->


                <div class="pt-3 mt-3">
                  <div class="heading">Questions:</div>
                   <div class="hr" style="margin-top: -10px; margin-bottom: 20px"/>
                  <!--<div v-for="(q, i) in coachup2.questions" class="pb-3" :key="i">-->
                  <!--  <span class="q-heading"> Question {{i+1}}:</span> {{clean_txt(q.question)}} <br>-->
                  <!--  <div v-if="q.answer != null">-->
                  <!--    <span class="q-heading">Answer {{i+1}}:</span> {{q.answer}}-->
                  <!--  </div>-->
                  <!--</div>-->


                   <div v-for="(q, i) in coachup2.questions" :class="compact? 'pb-1': 'pb-3'" :key="i">
                      <span class="q-heading"> Question {{i+1}}:</span> {{clean_txt(q.question)}} <br>
                      <div v-if="q.answer != null">
                         <span class="q-heading">Answer {{i+1}}:</span> {{q.answer}}
                      </div>
                   </div>

                </div>

                <!--<div class="pt-3">-->
                <!--  Links:-->
                <!--  <div v-for="(item, i) in coachup.additional_data.info_urls" :key="i">-->
                <!--    <a :key="i" style="color:blue;" :href="item" target="_blank">-->
                <!--      {{item}}-->
                <!--    </a>-->
                <!--  </div>-->

                <!--</div>-->
                <!--<div class="pt-2" v-if="!isPhone">-->
                <!--  Additional Files: <br>-->
                <!--  <template v-for="(item, i) in coachup.additional_data.files">-->
                <!--    <div :key="i" class="pb-2">-->
                <!--      <a :key="item.file_id" @click="download_file(item.file_id)" style="color:blue;"> Download File {{i+1}}</a>-->
                <!--    </div>-->

                <!--  </template>-->
                <!--</div>-->


              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <!--<v-card-actions>-->
          <!--<v-spacer></v-spacer>-->
          <!--<v-btn color="primary" @click="show_viewGrade=false">Close</v-btn>-->
          <!--<v-btn color="primary" @click="tmp">get data</v-btn>-->
        <!--</v-card-actions>-->
      </v-card>




  </div>
</template>

<style scoped>
  .heading{
    padding-bottom: 10px;
    /*font-size: large;*/
    font-weight: bold;
    color: #6a6a6a;
  }

  .heading-compact{
      padding-bottom: 3px;
      /*font-size: large;*/
      font-weight: bold;
      color: #6a6a6a;
  }

  .value{
      font-weight: normal;
  }
  .q-heading{
    color: #6a6a6a;
    font-weight: bold;
  }

  .comments{
    /*border-color: gray;*/
    /*border: 1px solid #c2c2c2;*/
    padding: 5px;
  }


  td{
     padding-left: 5px;
     padding-right: 5px;
  }


</style>


<script>
   import axios from 'axios';
   import viewGrade from "@/components/viewGrade";
   import _ from 'lodash';
   import data_getters from '../mixins/data_getters';

   export default {
      name: "viewCoachup",
      components: {viewGrade},
      mixins: [data_getters],
      props: {
         coachup: null,
         show: null,
         showX: {type: Boolean, default: () => true},
         showPrint: {type: Boolean, default: () => true},
         compact: {type: Boolean, default: () => false},
      },
      data() {
         return {
            file_data: null,
            show_audio_controls: true,
            event_list: [],
            curriculum: {},

            showGrade: false,
         };
      },

      computed:{
         coachup2(){
           if (this.coachup == null){
              return null
           }

           let ans = _.cloneDeep(this.coachup);

           if (ans.grade_id == null){
              ans.grade_id = {
                 grade_letter: 'N/A',
                 curriculum: {name: 'N/A'},
                 info_lead: {
                    lead_source: 'N/A',
                    wanted_vehicle: ans.manual_data.info_lead.vehicle,
                    lead_arrived_date: ans.manual_data.info_lead.date_in,
                 },
                 info_customer: {
                    name_first: ans.manual_data.info_lead.customer,
                    name_last: '',
                 }
              };

              ans.coachup_curriculum = {
                 id: null
              }
           }

           return ans;

         },


         print_link(){
            return '/view-coachup-print/'+this.coachup2._id.toString();
         },

         heading_class(){
           if (this.compact){
              return 'heading-compact'
           }
           else{
              return 'heading'
           }
         },

        isPhone(){
           if (this.curriculum.email_template === 'PHONE' && this.coachup2.additional_data.files.length > 0) return true;
           return false;
        },

         // percent_played(){
         //   if (this.coachup2.player_data == undefined)
         //      return [];
         //
         //   let ans = [];
         //    let pd = this.coachup2.player_data;
         //
         //   if (this.isManager){
         //      for (let x in pd){
         //         ans.push({
         //            percent: pd[x].percent_completed,
         //            name: pd[x].user_info.name,
         //            email: pd[x].user_info.email,
         //         });
         //      }
         //
         //      console.log('debug')
         //      let sp = this.coachup2.sales_people;
         //      for (let x in sp){
         //         if (pd[sp[x].user_id] == undefined){
         //            ans.push({
         //               percent: 0,
         //               name: sp[x].name,
         //               email: sp[x].email,
         //            })
         //         }
         //      }
         //
         //
         //   }else{
         //      let user_id = this.$auth.profile.user_id;
         //      if (pd[user_id] !== undefined){
         //         ans.push({
         //            percent: pd[user_id].percent_completed,
         //            name: pd[user_id].user_info.name,
         //            email: pd[user_id].user_info.email,
         //         });
         //      }
         //   }
         //
         //   ans = ans.sort((a, b) => a.percent < b.percent ? 1 : -1);
         //   return ans;
         //
         // },

         isManager(){
           return  ['Admin', 'Manager', 'AcctManager', 'Grader'].includes(this.$auth.profile.user_role);
         }
      },


      methods:{


         separator(ix, array){
            if (ix < array.length-1){
               return ', ';
            }

            return '';
         },

         close(){
            this.$emit('close-parent')
         },

         async download_file(filename){

            let token = await this.$auth.getAxiosHeader();
            let url = this.$baseUrlApi + '/getFile';
            // let ext = filename.split('.');
            // ext = ext[ext.length];
            // let type = 'application/'+ext;


            let save_name = filename.split('/');
            save_name = save_name[save_name.length-1];

            axios({
               url: url,
               method: 'post',
               data: {file_key: filename},
               responseType: 'blob', // important
               headers: token['headers'],
            }).then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', save_name );
               document.body.appendChild(link);
               link.click();
            });

         },

         // tmp(){
         //    this.get_coachup({_id: '5d6700f73d8a63db28fc911a'});
         // },

         fmt_date(d){
            //assumes d is a string in yyyy-mm-dd fmt.  returns date in mm/dd/yyyy fmt
            let tmp = d.split('-');
            return `${tmp[1]}/${tmp[2]}/${tmp[0]}`;
         },



         clean_txt(txt){
           return txt.replace('<br>', ' ');
         },

         txt_to_html(txt){
            if (txt)
              return txt.replace(/(\r\n|\n|\r)/gm,"<br>");
            else
               return '';
         },
         // async get_coachup({_id}){
         //    let token = await this.$auth.getAxiosHeader();
         //
         //    let url = this.$baseUrlApi + '/getGradedLeads';
         //
         //    try {
         //       let {data} = await axios.post(url, {match: {_id: _id}}, token);
         //       this.coachup =  data[0];
         //
         //    }
         //    catch(err){
         //       console.log(err);
         //       this.coachup =  null;
         //
         //
         //    }
         // },

         player_event(event){
            // console.log('event', event)

            if (this.$refs.mp3_player){

               let e2 = {
                  event: event.type,
                  player_position:  this.$refs.mp3_player.currentTime,
                  player_time_total: this.$refs.mp3_player.duration,
                  player_volume: this.$refs.mp3_player.volume,
                  player_muted: this.$refs.mp3_player.muted,

                  time_stamp: new Date(),
                  // user_id: this.$auth.profile.user_id
               }
               this.event_list.push(e2)
               // if (event.type === 'play') this.filter_seek_event();
               console.log('event2', e2)
               this.debouncd_event_update();
            }


         },

         filter_seek_event(){
           //filter out the pause/play events that happen before/after a seeked event
            let n = this.event_list.length;
           if (n < 3){
              return;
           }

           if  (this.event_list[n-3].player_position === this.event_list[n-2].player_position
               && this.event_list[n-2].player_position === this.event_list[n-1].player_position){
              console.log('i ran')
              this.event_list.splice(n-3, 1);
              this.event_list.pop();
           }

         },
         async update_player_info(){
            try{
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/updateGradedLeadPlayerData';
               let post_data = {
                  user_id: this.$auth.profile.user_id,
                  user_name: this.$auth.profile.name,
                  user_email: this.$auth.profile.email,
                  lead_id: this.coachup2._id,

                  player_data: this.event_list,
               }
               this.event_list = [];
               var res = await axios.post(url, post_data, token);

            }
            catch(e){
               console.log(e)
            }
         },

         async get_file_data(filename){
            let token = await this.$auth.getAxiosHeader();
            let url = this.$baseUrlApi + '/getFile';
            // let ext = filename.split('.');
            // ext = ext[ext.length];
            // let type = 'application/'+ext;


            let save_name = filename.split('/');
            save_name = save_name[save_name.length-1];

            axios({
               url: url,
               method: 'post',
               data: {file_key: filename},
               responseType: 'blob', // important
               headers: token['headers'],
            }).then((response) => {
               console.log('response', response)
               this.file_data = window.URL.createObjectURL(new Blob([response.data]));

            });


         },
      },
      created(){

         // let files = [];
         // if (this.coachup.additional_data.files != undefined){
         //    files = this.coachup.additional_data.files;
         // }
         // if (files.length === 1  ){
         //    this.get_file_data(files[0].file_id)
         // }

         // this.debouncd_event_update = _.debounce(this.update_player_info, 500);

      },


      async mounted(){

         if (this.coachup2 != null && this.coachup2.coachup_curriculum){
            let tmp = await  this.get_curricula({_id: this.coachup2.coachup_curriculum.id});
            if (tmp.length === 1){
               this.curriculum = tmp[0];
            }
         }
         else{
            this.curriculum = {};
         }

      },

      // async beforeDestroy() {
      //    if (this.$refs.mp3_player && !this.$refs.mp3_player.paused){
      //       let e2 = {
      //          event: 'close_page',
      //          player_position:  this.$refs.mp3_player.currentTime,
      //          player_time_total: this.$refs.mp3_player.duration,
      //          player_volume: this.$refs.mp3_player.volume,
      //          player_muted: this.$refs.mp3_player.muted,
      //          time_stamp: new Date(),
      //       }
      //       this.event_list.push(e2)
      //    }
      //
      //
      //    if (this.event_list.length > 0)
      //       await this.update_player_info();
      // }
   };
</script>


